import { store } from '../store/premiumTravelStore';
import { PremiumExperienceType } from '../store/premiumTravelStore';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('persistResponse', function persistResponse(
    response: PremiumExperienceType
) {
    if (response) {
        store.premiumExperienceType = response;
    }
    store.isInit = true;
});
